module.exports = __webpack_public_path__ + "img/main_menu_login_not.6622515c.svg";